import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	learnMoreButtonText: {
		id: 'atlassian-navigation-recommendations.jpd-recommendation.learn-more-button-text',
		defaultMessage: 'Why am I seeing this?',
		description: 'Text for users to find more information about the recommendation',
	},
	projectDescription: {
		id: 'atlassian-navigation-recommendations.jpd-recommendation.project-description',
		defaultMessage: 'Capture ideas with Jira Product Discovery',
		description: 'Project description when resurfacing unused ITSM project',
	},
	projectDescriptionProductRoadmap: {
		id: 'atlassian-navigation-recommendations.jpd-recommendation.project-description-roadmap',
		defaultMessage: 'Jira Product Discovery project',
		description: 'Project description for Jira Product Roadmap template',
	},
	lozengeText: {
		id: 'atlassian-navigation-recommendations.jpd-recommendation.lozenge-text',
		defaultMessage: 'try',
		description: 'Lozenge indicating users to try the product',
	},
	dismissButtonText: {
		id: 'atlassian-navigation-recommendations.jpd-recommendation.dismiss-button-text',
		defaultMessage: 'Not interested',
		description:
			'Text for the "Not interested" button in the "setup required" section of the projects dropdown',
	},
	recommendedText: {
		id: 'atlassian-navigation-recommendations.jpd-recommendation.recommended-text',
		defaultMessage: 'Recommended',
		description: 'Text for recommended section for projects dropdown',
	},
	dismissConfirmationTitle: {
		id: 'atlassian-navigation-recommendations.jpd-recommendation.dismiss-confirmation-title',
		defaultMessage: 'Got it, thanks for letting us know',
		description: 'Title for the confirmation flag when the user clicks the "Not interested" button',
	},
	dismissConfirmationText: {
		id: 'atlassian-navigation-recommendations.jpd-recommendation.dismiss-confirmation-text',
		defaultMessage: "You won't be seeing this here anymore",
		description: 'Text for the confirmation flag when the user clicks the "Not interested" button',
	},
	projectTitle: {
		id: 'atlassian-navigation-recommendations.jpd-recommendation.project-title',
		defaultMessage: 'New discovery project',
		description: 'Project description when resurfacing unused ITSM project',
	},
	projectTitleProductRoadmap: {
		id: 'atlassian-navigation-recommendations.jpd-recommendation.project-title-product-roadmap',
		defaultMessage: 'Create a roadmap',
		description: 'Project title for the Jira Product Roadmap template',
	},
	reasonsModalTitle: {
		id: 'atlassian-navigation-recommendations.jpd-recommendation.reasons-modal-title',
		defaultMessage: 'Why am I seeing this?',
		description: 'Title of the reasons modal',
	},
	reasonsModalExplanation: {
		id: 'atlassian-navigation-recommendations.jpd-recommendation.reasons-modal-explanation',
		defaultMessage:
			"We think <strong>Jira Product Discovery</strong> will improve your team's productivity. The recommendation is based on:",
		description: 'Explanation as to why the placeholder template is being shown',
	},
	reasonsModalBulletOneSpork: {
		id: 'atlassian-navigation-recommendations.jpd-recommendation.reasons-modal-bullet-one-spork',
		defaultMessage: 'the tools you use (Jira)',
		description: 'First bullet point of the reasons modal',
	},
	reasonsModalBulletTwo: {
		id: 'atlassian-navigation-recommendations.jpd-recommendation.reasons-modal-bullet-two',
		defaultMessage: 'the way you use your existing tools and products',
		description: 'Second bullet point of the reasons modal',
	},
	privacyPolicy: {
		id: 'atlassian-navigation-recommendations.jpd-recommendation.privacy-policy',
		defaultMessage: 'Learn more about your data privacy with Atlassian',
		description: "Link to Atlassian's privacy policy",
	},
	reasonsModalButtonOk: {
		id: 'atlassian-navigation-recommendations.jpd-recommendation.reasons-modal-button-ok',
		defaultMessage: 'Ok',
		description: 'Ok text for the reasons modal',
	},
	reasonsModalButtonOkCapitalised: {
		id: 'atlassian-navigation-recommendations.jpd-recommendation.reasons-modal-button-ok-capitalised',
		defaultMessage: 'OK',
		description: 'Ok text for the reasons modal',
	},
});
